/**
 * Serialize/deserialize props for embedding in a `data-props` HTML attribute.
 *
 * Uses the native `btoa`/`atob` and `TextEncoder`/`TextDecoder` globals, which
 * are available in both Node and the browser, so nothing extra is bundled on
 * the client. The `TextEncoder`/`TextDecoder` round-trip keeps non-latin1
 * characters (e.g. æøå and Finnish text) intact, which `btoa` alone cannot do.
 *
 * The output is plain base64, byte-compatible with the previous
 * `@finn-no/safe-props` implementation.
 */
export const encode = (props: unknown): string => {
    const bytes = new TextEncoder().encode(JSON.stringify(props));
    let binary = '';
    for (const byte of bytes) {
        binary += String.fromCharCode(byte);
    }
    return btoa(binary);
};

export const decode = <T>(encoded: string): T => {
    const bytes = Uint8Array.from(atob(encoded), (c) => c.charCodeAt(0));
    return JSON.parse(new TextDecoder().decode(bytes)) as T;
};
